import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@src/app/components';
import { TranslateModule } from '@ngx-translate/core';

import { ConfigDocumentsComponent } from './components';
import { AppConfigService } from './app-config.service';

@NgModule({
  declarations: [ConfigDocumentsComponent],
  imports: [CommonModule, ComponentsModule, TranslateModule],
  providers: [AppConfigService],
  exports: [ConfigDocumentsComponent],
})
export class AppConfigModule {}
